import styled from 'styled-components/macro';
import { baseSpacing, colors } from 'css/constants';

export const Input = styled.input`
  border-width: 1px;
  border-style: solid;
  border-color: ${({ haserror }) => (haserror ? colors.red : '#CCCCCB')};
  border-radius: 3px;
  display: flex;
  padding: 0.5em;
  position: relative;
  margin-bottom: ${({ withMarginBottom }) =>
    withMarginBottom ? `${baseSpacing / 4}px` : '0'};
  width: ${({ width }) => width || '100%'};
  flex-wrap: wrap;
  align-items: center;
  color: ${({ theme }) => theme.text};

  &:disabled {
    color: ${({ theme }) => theme.text};
  }

  & > div {
    flex-basis: 100%;
  }

  &[type='radio'],
  &[type='checkbox'] {
    display: inline-block;
    width: auto;
    padding: 0;
    border: none;
  }
`;

export const ReadOnlyInput = styled(Input)`
  background-color: ${colors.lightGrey};
  border: 1px solid ${colors.lightGrey};
`;

export default Input;
